export default __webpack_public_path__ + "static/media/elevate-cbb-2.a3c108a4.png";